import { useEffect, useState } from "react";
import { faArrowDown, faArrowUp, faEye, faFileInvoiceDollar } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { Button } from "react-bootstrap";
import { connect } from "react-redux";

import ConveniosFilter from "../../../components/Filter/ConveniosFilter";
import { getPlanes, setEstado } from "../../../redux/Sections/PlanesDePago/actions";
import { getAbogados } from "../../../redux/Sections/Abogados/actions";
// import icon from "../../../assets/static/images/secciones/plandepagos.png";
import PlanDePagoModal from "../../../components/PlanDePagoModal/PlanDePagoModal";
import SimularPlan from "./SimularPlan";
import { Tabla } from "../../../components/Table/Table";
import { formatDate2 } from "../../../utils/utils";
import { faFileAlt } from "@fortawesome/free-regular-svg-icons";
import TooltipText from "../../../components/TooltipText";
import "./PlanesDePago.css";
import { useUser } from "../../../hooks/useUser";


const PlanesDePago = ({ dataList, getPlanes, getAbogados, abogados }) => {
  const [showFilter, setShowFilter] = useState(true);
  const [filters, setFilters] = useState({});
  const [showPlan, setShowPlan] = useState(false);
  const [planDePago, setPlanDePago] = useState({});
  const [convenio, setConvenio] = useState("");

  const [showTable, setShowTable] = useState(false);
  const [showSimularPlan, setShowSimularPlan] = useState(false);
  const user = useUser();
  useEffect(() => {
    getAbogados();
  }, []);

  const handleOpen = (values) => {
    setPlanDePago(values);
    setShowPlan(true);
  };

  const handleOpenConvenio = (values) => {
    setShowPlan(true);
    setConvenio(values.convenio);
  };

  const handleClose = () => {
    setShowPlan(false);
    setPlanDePago("");
    setConvenio("");
  };

  const handleOpenPlan = (values) => {
    setPlanDePago(values);
    setShowSimularPlan(true);
  };
  const handleClosePlan = () => {
    setShowSimularPlan(false);
  };


  const columns = [
    {
      title: "FECHA",
      dataIndex: "fc_confirma",
      key: "fc_confirma",
    },
    {
      title: "CONTRIBUYENTE",
      dataIndex: "frm_nombre",
      key: "frm_nombre",
    },
    {
      title: "ABOGADO",
      dataIndex: "imponible",
      key: "imponible",
    },
    {
      title: "RECURSO",
      dataIndex: "recurso",
      key: "recurso",
    },
    {
      title: "NÚMERO DE PLAN",
      dataIndex: "plan",
      key: "plan",
    },
    {
      title: "CUOTAS",
      dataIndex: "cuotas",
      key: "cuotas",
    },
    {
      title: "OBSERVACIÓN",
      dataIndex: "obs",
      key: "obs",
    },
    {
      title: "ESTADO",
      dataIndex: "estado_nombre",
      key: "estado_nombre",
    },
    {
      title: "PLANES",
      render: (_, row) => {
        return row.plan ? (
          <div
            className="d-flex justify-content-center align-items-center"
            style={{
              cursor: "pointer"
            }}
          >
            <TooltipText placement="bottom" text="Ver Planes de pago." >
              <FontAwesomeIcon
                onClick={() => handleOpen(row)}
                icon={faEye}
                size="lg"
              />
            </TooltipText>
          </div>
        ) : row.convenio ? (
          <div
            className="d-flex justify-content-center align-items-center"
            style={{
              cursor: "pointer"
            }}
          >
            <TooltipText placement="bottom" text="Ver Convenio." >
              <FontAwesomeIcon
                onClick={() => handleOpenConvenio(row)}
                icon={faFileAlt}
                size="lg"
              />
            </TooltipText>
          </div>
        ) : null;
      }
    }
  ];


  const formatData = (data) => {
    try {
      return data
        .filter(d => d?.planes)
        .map(e => {
          const planes = JSON.parse(e.planes);

          let abogado = abogados.find(a => a.codexterno === e.codexterno);

          return planes.map((p) => {
            return {
              ...e,
              ...p,
              fc_confirma: e.fc_confirma ? e.fc_confirma !== "0000-00-00" ? formatDate2(e.fc_confirma) : "Sin confirmar"  : "",
              NRO_PLAN: p.plan,
              abogado
            };
          });
        })
        .flat();
    }
    catch (err) {
      console.log("err", err);
      return [];
    }
  };


  return (
    <div className="mt-2">
      {/* <div className="section-title d-flex align-items-center">
        <img src={icon} alt="planes-de-pago" />
        <span>Planes de Pago</span>
      </div> */}
      { user.rol !== "guest"
        ? <div className="d-flex justify-content-start w-100 p-3" >
          <div>
            <Button
              onClick={handleOpenPlan}
              className="custom-button d-flex align-items-center"
            >
              <FontAwesomeIcon icon={faFileInvoiceDollar} size="1x" />
              <span className="ml-2">Simular plan de pago</span>
            </Button>
          </div>
        </div>
        : null
      }

      <div className="buttons-filter">
        <h3 className="mr-3">Filtros:</h3>
        <div className="button-filter">
          {showFilter ? (
            <Button
              variant="danger"
              onClick={() => setShowFilter(false)}
              className="danger-button d-flex align-items-center"
              style={{ maxWidth: 105 }}
            >
              <FontAwesomeIcon icon={faArrowDown} size="1x" /><span className="ml-2">Ocultar</span>
            </Button>
          )
            : (
              <Button
                onClick={() => setShowFilter(true)}
                className="custom-button d-flex align-items-center"
                style={{ maxWidth: 105 }}
              ><FontAwesomeIcon icon={faArrowUp} size="1x" /><span className="ml-2">Mostrar</span>
              </Button>
            )
          }
        </div>
      </div>
      <div className="section-filter">
        <ConveniosFilter showFilter={showFilter} setShowFilter={setShowFilter} action={getPlanes} setShowTable={setShowTable} setFilters={setFilters} planDePago={true} />
      </div>
      {showTable ? (
        <div className="section-table">
          <Tabla dataList={formatData(dataList)} columns={columns} />
          {/* <div className="mt-3">
            <div style={{ maxWidth: 170 }}>
              <DescargarExcel data={exportData(dataList)} />
            </div>
          </div> */}
        </div>
      ) : null}


      {showSimularPlan ? <SimularPlan show={showSimularPlan} handleClose={handleClosePlan} /> : null}
      {showPlan ? <PlanDePagoModal show={showPlan} handleClose={handleClose} data={planDePago} imponible={planDePago.NRO_INMUEBLE} recurso={planDePago.RECURSO} filters={filters} getPlanes={getPlanes} convenio={convenio} /> : null}
    </div>
  );
};


const mapStateToProps = (state) => {
  return {
    dataList: state.dashboard.planesList,
    tiposRetiro: state.dashboard.tiposRetiro,
    abogados: state.dashboard.abogadosList,
  };
};

const mapDispatchToProps = (dispatch) => {
  return {
    setEstado: (data) => dispatch(setEstado(data)),
    getPlanes: (data) => dispatch(getPlanes(data)),
    getAbogados: () => dispatch(getAbogados()),
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(PlanesDePago);